import React from "react";
import { PlayerFlag } from "../../components/Flag";

function surname(name) {
  const parts = name.split(" ");
  return parts[parts.length - 1];
}

function SmallFace({ player }) {
  return (
    <div className="w-9 h-9 rounded-full overflow-hidden border border-zinc-700 grid place-items-center bg-zinc-800">
      <PlayerFlag nation={player.nation} />
    </div>
  );
}

export default function MobilePitchBar({
  slots,
  roster,
  compatibleSlots,
  selectedPlayer,
  onPlace,
}) {
  return (
    <div className="shrink-0 border-t border-zinc-800 bg-zinc-950/90 px-3 py-3">
      <div className="flex flex-wrap justify-center gap-2">
        {slots.map((slot) => {
          const player = roster[slot.id];
          const eligible =
            !player && !!selectedPlayer && compatibleSlots.includes(slot.id);
          return (
            <button
              key={slot.id}
              type="button"
              disabled={!eligible}
              onClick={() => eligible && onPlace(slot.id)}
              className={`w-[58px] rounded-xl border flex flex-col items-center gap-1 py-1.5 transition
                ${
                  player
                    ? "bg-zinc-900 border-emerald-500/60"
                    : eligible
                      ? "bg-zinc-900/70 border-emerald-400 shadow-lg shadow-emerald-500/30 animate-pulse"
                      : "bg-zinc-900/30 border-dashed border-zinc-700"
                }`}
            >
              {player ? (
                <SmallFace player={player} />
              ) : (
                <div className="w-9 h-9 grid place-items-center text-[10px] font-semibold text-zinc-500">
                  {slot.label}
                </div>
              )}
              <span
                className={`text-[9px] font-semibold tracking-wide truncate max-w-full
                  ${
                    player
                      ? "text-zinc-300"
                      : eligible
                        ? "text-emerald-300"
                        : "text-zinc-600"
                  }`}
              >
                {player ? surname(player.name) : slot.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
